import { brandLogoKey, brandNameLogoKey, brandTagKey } from '../config/constants';

export const removeBrandConfigurations = () => {
  localStorage.removeItem(brandTagKey);
  localStorage.removeItem(brandNameLogoKey);
  localStorage.removeItem(brandLogoKey);
};

export const setBrandConfigurations = (
  brandTag: string,
  brandNameLogo: string,
  brandLogo: string
) => {
  localStorage.setItem(brandTagKey, brandTag);
  localStorage.setItem(brandNameLogoKey, brandNameLogo);
  localStorage.setItem(brandLogoKey, brandLogo);
};
